<template>
  <div>
    <v-list v-if="layout == 'list'">
      <v-list-item
        v-for="(e, i) in source"
        :key="i"
        @click="$emit('click-item', e)"
        class="news-list"
        :class="layoutClass"
      >
        <v-list-item-content class="news-list-item" :class="layoutClass">
          <v-list-item-title class="news-list-title" :class="layoutClass">
            {{ e.title }}
          </v-list-item-title>
          <v-list-item-subtitle class="news-list-subtitle" :class="layoutClass">
            {{ dateToString(e.date) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else-if="layout == 'snippet'">
      <v-list-item
        v-for="(e, i) in source"
        :key="i"
        @click="$emit('click-item', e)"
        class="news-list"
        :class="layoutClass"
      >
        <v-list-item-content class="news-list-item" :class="layoutClass">
          <v-lazy transition="fade-transition">
            <v-card outlined elevation="0">
              <v-card-title class="news-list-title" :class="layoutClass">
                {{ e.title }}
              </v-card-title>
              <v-card-subtitle class="news-list-subtitle" :class="layoutClass">
                {{ dateToString(e.date) }}
              </v-card-subtitle>
              <v-card-text class="news-list-content" :class="layoutClass">
                {{ e.contentSnippet }}
              </v-card-text>
            </v-card>
          </v-lazy>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list v-else-if="layout == 'post'">
      <v-list-item
        v-for="(e, i) in source"
        :key="i"
        @click="$emit('click-item', e)"
        class="news-list"
        :class="layoutClass"
      >
        <v-list-item-content class="news-list-item" :class="layoutClass">
          <v-lazy transition="fade-transition">
            <v-card outlined>
              <v-card-title class="news-list-title" :class="layoutClass">
                {{ e.title }}
              </v-card-title>
              <v-card-subtitle class="news-list-subtitle" :class="layoutClass">
                {{ dateToString(e.date) }}
              </v-card-subtitle>
              <v-card-text class="news-list-content" :class="layoutClass">
                <scoped-page-view :html="e.content" :relative-to="e.link" />
              </v-card-text>
            </v-card>
          </v-lazy>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import ScopedPageView from "@/components/ScopedPageView";
import toDateString from "@/mixins/toDateString";
export default {
  props: ["source", "layout"],
  mixins: [toDateString],
  components: {
    ScopedPageView,
  },
  computed: {
    layoutClass: function () {
      return [
        "layout-" + this.layout,
        this.$vuetify.breakpoint.mobile ? "mobile" : "tablet",
      ];
    },
  },
};
</script>

<style scoped>
.layout-list.tablet.news-list-item {
  flex-wrap: nowrap;
}
.layout-list.tablet.news-list-subtitle {
  flex: 0 0 auto;
}
.layout-snippet.news-list-content {
  max-height: 64px;
  overflow: hidden;
  padding-bottom: 0px;
  margin-bottom: 16px;
}
</style>